module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAAAXNSR0IArs4c6QAAADlQTFRFAAAA/wAAvF5ev2Bgu15eu1xcvFxculxcu11du11du11du11du11dvF5ewmFhx2NjyGRkzmdn02lpIPKpygAAAAx0Uk5TAAEmKG10o661wOv6HcKOYgAAAFhJREFUKM+t0NEOgCAIBVBKzdQK9f8/tgceIKLVlueJecdwF2CkyZhIR9L1Cm4EPwdxIfH/f9Oqpetxhi9ByVoxi3h6E4JnQQZ1Z9Xq6tZXO1iTgZuZg/FOCjUHO4kN1tMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/home/home_3_icon2.png
// module id = e3K3
// module chunks = 2